import { initializeApp } from "https://www.gstatic.com/firebasejs/10.8.0/firebase-app.js";
import { getAuth, signInWithPopup, GoogleAuthProvider, signInWithCustomToken } from "https://www.gstatic.com/firebasejs/10.8.0/firebase-auth.js";

const BACKEND_URL = "https://api.ottavio.ma/api";

const firebaseConfig = {
  apiKey: "AIzaSyC_e8Qc5nfuK1NSoZZwrmAUfVuoYha9YsA",
  authDomain: "ottavioshoes-d7911.firebaseapp.com",
  projectId: "ottavioshoes-d7911",
  storageBucket: "ottavioshoes-d7911.firebasestorage.app",
  messagingSenderId: "1033041991836",
  appId: "1:1033041991836:web:829cc5e25b4bead0baf559",
  measurementId: "G-F53X3L1DWS"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

document.addEventListener("DOMContentLoaded", () => {
  const bellBtn = document.getElementById("header-notif-bell");
  const dropdown = document.getElementById("header-notif-dropdown");
  const badge = document.getElementById("header-notif-badge");

  if (!bellBtn || !dropdown) return;

  function isUserLoggedIn() {
    const customerId = localStorage.getItem("customer_id");
    const token = localStorage.getItem("auth_token");
    if (!customerId || customerId === "null" || customerId === "undefined" || !token || token === "null" || token === "undefined") {
      return false;
    }
    return true;
  }

  // Toggle dropdown on bell click
  bellBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isVisible = dropdown.classList.contains("open");
    
    // Close other dropdowns if any
    document.querySelectorAll(".header__notif-dropdown").forEach(el => el.classList.remove("open"));
    
    if (!isVisible) {
      dropdown.classList.add("open");
      renderDropdownContent();
    } else {
      dropdown.classList.remove("open");
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target) && e.target !== bellBtn && !bellBtn.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  });

  // Initial check for unread count
  updateUnreadCount();

  async function updateUnreadCount() {
    if (!isUserLoggedIn()) {
      badge.style.display = "none";
      return;
    }
    const customerId = localStorage.getItem("customer_id");
    try {
      const res = await fetch(`${BACKEND_URL}/notifications-list?shopify_customer_id=${customerId}`);
      const data = await res.json();
      if (data.success) {
        const unread = (data.notifications || []).filter(n => !n.isRead).length;
        if (unread > 0) {
          badge.style.display = "flex";
          badge.innerText = unread;
        } else {
          badge.style.display = "none";
        }
      } else {
        badge.style.display = "none";
      }
    } catch (e) {
      badge.style.display = "none";
    }
  }

  function renderDropdownContent() {
    if (isUserLoggedIn()) {
      // User is logged in, show notifications
      renderNotificationsList(localStorage.getItem("customer_id"));
    } else {
      // User is logged out, show login forms
      renderLoginForm();
    }
  }

  async function renderNotificationsList(customerId) {
    dropdown.innerHTML = `<div style="text-align: center; color: #666; padding: 20px;"><i class="fas fa-spinner fa-spin" style="margin-right: 8px;"></i>Chargement...</div>`;
    
    try {
      const res = await fetch(`${BACKEND_URL}/notifications-list?shopify_customer_id=${customerId}`);
      const data = await res.json();
      
      if (data.success) {
        const notifs = data.notifications || [];
        if (notifs.length === 0) {
          dropdown.innerHTML = `
            <div style="text-align: center; padding: 20px; color: #666;">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: 8px; display: inline-block;">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
              <div style="font-size: 14px; font-weight: 500;">Aucune notification</div>
            </div>
          `;
          return;
        }

        // Render last 3 notifications
        const listHtml = notifs.slice(0, 3).map(n => {
          let dateStr = n.date;
          try {
            const d = new Date(n.date);
            if (!isNaN(d)) dateStr = d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
          } catch(e){}

          return `
            <div class="header-notif-item ${!n.isRead ? 'unread' : ''}" style="padding: 10px 0; border-bottom: 1px solid #F0F0F0; cursor: pointer; text-align: left;" data-id="${n.id}">
              <div style="font-size: 11px; color: #999; margin-bottom: 2px;">${dateStr}</div>
              <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 2px;">${n.title}</div>
              <div style="font-size: 12px; color: #666; line-height: 1.3;">${n.body}</div>
            </div>
          `;
        }).join('');

        dropdown.innerHTML = `
          <div style="font-size: 14px; font-weight: 700; color: #1A1A1A; border-bottom: 1px solid #F0F0F0; padding-bottom: 8px; margin-bottom: 8px; text-align: left;">Notifications</div>
          <div style="max-height: 220px; overflow-y: auto;">${listHtml}</div>
          <div style="text-align: center; margin-top: 12px; padding-top: 8px; border-top: 1px solid #F0F0F0;">
            <a href="/pages/profile" style="font-size: 12px; font-weight: 600; color: #D4AF37; text-decoration: none;">Voir toutes les notifications</a>
          </div>
        `;

        // Click to mark as read
        dropdown.querySelectorAll(".header-notif-item").forEach(item => {
          item.addEventListener("click", async () => {
            const id = item.dataset.id;
            item.classList.remove("unread");
            try {
              await fetch(`${BACKEND_URL}/notifications-read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ shopify_customer_id: customerId, notification_id: id })
              });
              updateUnreadCount();
            } catch(e){}
          });
        });

      } else {
        // Self-heal: if backend rejects the session (invalid customer_id / mapping), clear it and show login form
        console.warn("Invalid session detected, clearing localStorage:", data.message);
        localStorage.removeItem("customer_id");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_phone");
        localStorage.removeItem("user_email");
        renderLoginForm();
      }
    } catch (e) {
      dropdown.innerHTML = `<div style="text-align: center; color: red; font-size: 13px; padding: 20px;">Erreur de connexion.</div>`;
    }
  }

  function renderLoginForm() {
    dropdown.innerHTML = `
      <div id="dropdown-login-initial">
        <h4 style="margin: 0 0 4px 0; font-size: 15px; font-weight: 700; color: #1A1A1A; text-align: left;">Connexion</h4>
        <p style="margin: 0 0 16px 0; font-size: 12px; color: #666; text-align: left; line-height: 1.4;">Accédez à vos notifications, points de fidélité et favoris.</p>
        
        <button id="dropdown-btn-google" style="width: 100%; padding: 12px; border-radius: 8px; border: 1px solid #E5E5E5; background: #FFF; color: #1A1A1A; font-family: inherit; font-size: 13px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 12px; transition: background 0.2s;">
          <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continuer avec Google
        </button>

        <div style="display: flex; align-items: center; margin: 12px 0; color: #999; font-size: 11px;">
          <div style="flex: 1; height: 1px; background: #E5E5E5;"></div>
          <span style="padding: 0 8px;">OU</span>
          <div style="flex: 1; height: 1px; background: #E5E5E5;"></div>
        </div>

        <div style="margin-bottom: 12px; text-align: left;">
          <label style="display: block; font-size: 11px; font-weight: 600; color: #666; margin-bottom: 6px;">Numéro WhatsApp</label>
          <div style="display: flex; align-items: center; background: #F5F5F5; border-radius: 8px; padding: 0 12px; border: 1px solid #E5E5E5;" id="phone-input-container">
            <span style="color: #666; font-size: 13px; margin-right: 8px;">🇲🇦 +212</span>
            <input type="tel" id="dropdown-phone-input" style="flex: 1; border: none; background: transparent; padding: 10px 0; font-size: 13px; font-family: inherit; color: #1A1A1A; outline: none;" placeholder="6 00 00 00 00" maxlength="10">
          </div>
        </div>

        <button id="dropdown-btn-whatsapp" style="width: 100%; padding: 12px; border-radius: 8px; border: none; background: #25D366; color: #FFF; font-family: inherit; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.2s;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style="display: inline-block;">
            <path d="M12.012 2c-5.506 0-9.988 4.482-9.988 9.988 0 1.76.457 3.473 1.328 4.98l-1.41 5.15 5.27-1.384a9.92 9.92 0 0 0 4.8 1.238h.005c5.506 0 9.988-4.482 9.988-9.988C22 6.482 17.518 2 12.012 2zm6.75 14.15c-.277.777-1.616 1.488-2.235 1.576-.575.083-1.326.155-3.834-.848-3.21-1.282-5.223-4.582-5.383-4.797-.16-.215-1.282-1.706-1.282-3.256 0-1.55.812-2.313 1.1-.28.16.27.228.326.272.415.044.089.022.166-.01.233-.033.067-.343.82-.42.986-.078.166-.16.343.01.637.172.295.768 1.267 1.65 2.052.882.785 1.62 1.028 1.952 1.194.331.166.52.144.714-.078.193-.222.84-.975 1.062-1.307.222-.332.443-.277.747-.166.304.11 1.93.91 2.262 1.076.331.166.553.249.637.388.083.139.083.805-.194 1.582z"/>
          </svg>
          Envoyer le code
        </button>
      </div>

      <div id="dropdown-login-otp" style="display: none;">
        <button id="dropdown-btn-back-phone" style="background: none; border: none; color: #666; font-size: 11px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 4px; margin-bottom: 12px; padding: 0;">
          ← Retour
        </button>
        <h4 style="margin: 0 0 4px 0; font-size: 15px; font-weight: 700; color: #1A1A1A; text-align: left;">Vérification</h4>
        <p style="margin: 0 0 16px 0; font-size: 12px; color: #666; text-align: left; line-height: 1.4;">Entrez le code à 6 chiffres envoyé au <strong id="dropdown-display-phone"></strong></p>

        <input type="text" id="dropdown-otp-input" style="width: 100%; padding: 12px; border-radius: 8px; border: 1px solid #E5E5E5; background: #F5F5F5; text-align: center; font-size: 18px; font-weight: 700; letter-spacing: 6px; outline: none; margin-bottom: 16px; box-sizing: border-box;" maxlength="6" placeholder="000000">

        <button id="dropdown-btn-verify" style="width: 100%; padding: 12px; border-radius: 8px; border: none; background: #1A1A1A; color: #FFF; font-family: inherit; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px;">
          Vérifier et continuer
        </button>
      </div>
    `;

    // Google Sign-in handler
    const googleBtn = document.getElementById("dropdown-btn-google");
    googleBtn.addEventListener("click", async () => {
      setLoading(googleBtn, true, "Connexion...");
      try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;
        
        const syncRes = await fetch(`${BACKEND_URL}/sync-customer`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            uid: user.uid,
            email: user.email,
            name: user.displayName,
            phone: user.phoneNumber || ''
          })
        });
        
        const data = await syncRes.json();
        if (data.success) {
          localStorage.setItem('auth_token', await user.getIdToken());
          localStorage.setItem('customer_id', data.shopify_customer_id);
          localStorage.setItem('user_name', user.displayName || 'Client');
          localStorage.setItem('user_email', user.email);
          
          updateUnreadCount();
          renderDropdownContent();
        } else {
          alert("Erreur de synchronisation.");
        }
      } catch (error) {
        console.error(error);
        alert("Erreur Google Auth: " + error.message);
      } finally {
        setLoading(googleBtn, false, "Continuer avec Google");
      }
    });

    // WhatsApp Phone/OTP handlers
    const whatsappBtn = document.getElementById("dropdown-btn-whatsapp");
    const phoneInput = document.getElementById("dropdown-phone-input");
    const phoneContainer = document.getElementById("phone-input-container");

    phoneInput.addEventListener("focus", () => phoneContainer.style.borderColor = "#25D366");
    phoneInput.addEventListener("blur", () => phoneContainer.style.borderColor = "#E5E5E5");

    whatsappBtn.addEventListener("click", async () => {
      let rawPhone = phoneInput.value.replace(/\D/g, '');
      if (rawPhone.startsWith('0')) rawPhone = rawPhone.substring(1);
      
      if (rawPhone.length !== 9) {
        alert("Veuillez entrer un numéro valide à 9 chiffres (ex: 600000000).");
        return;
      }
      
      const phone = "+212" + rawPhone;
      setLoading(whatsappBtn, true, "Envoi...");

      try {
        const res = await fetch(`${BACKEND_URL}/whatsapp-otp`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'send', phone: phone })
        });
        const data = await res.json();
        
        if (data.success) {
          document.getElementById("dropdown-login-initial").style.display = "none";
          document.getElementById("dropdown-login-otp").style.display = "block";
          document.getElementById("dropdown-display-phone").innerText = phone;
          document.getElementById("dropdown-otp-input").focus();
        } else {
          alert("Erreur: " + data.message);
        }
      } catch (err) {
        alert("Erreur: " + err.message);
      } finally {
        setLoading(whatsappBtn, false, "Envoyer le code");
      }
    });

    // Back to Phone Form
    const backBtn = document.getElementById("dropdown-btn-back-phone");
    backBtn.addEventListener("click", () => {
      document.getElementById("dropdown-login-otp").style.display = "none";
      document.getElementById("dropdown-login-initial").style.display = "block";
    });

    // Verify OTP Handler
    const verifyBtn = document.getElementById("dropdown-btn-verify");
    const otpInput = document.getElementById("dropdown-otp-input");

    verifyBtn.addEventListener("click", async () => {
      const code = otpInput.value;
      let rawPhone = phoneInput.value.replace(/\D/g, '');
      if (rawPhone.startsWith('0')) rawPhone = rawPhone.substring(1);
      const phone = "+212" + rawPhone;

      if (code.length < 6) {
        alert("Veuillez entrer le code à 6 chiffres.");
        return;
      }

      setLoading(verifyBtn, true, "Vérification...");

      try {
        const res = await fetch(`${BACKEND_URL}/whatsapp-otp`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'verify', phone: phone, code: code })
        });
        const data = await res.json();
        
        if (data.success && data.customToken) {
          const userCredential = await signInWithCustomToken(auth, data.customToken);
          const user = userCredential.user;
          
          // Sync with Shopify
          const syncRes = await fetch(`${BACKEND_URL}/sync-customer`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              uid: user.uid,
              phone: phone,
              name: "Client"
            })
          });
          
          const syncData = await syncRes.json();
          if (syncData.success) {
            localStorage.setItem('auth_token', await user.getIdToken());
            localStorage.setItem('customer_id', syncData.shopify_customer_id);
            localStorage.setItem('user_name', 'Client');
            localStorage.setItem('user_phone', phone);
            
            updateUnreadCount();
            renderDropdownContent();
          } else {
            alert("Erreur de synchronisation.");
          }
        } else {
          alert("Code incorrect: " + data.message);
          otpInput.value = "";
          otpInput.focus();
        }
      } catch (err) {
        alert("Erreur système: " + err.message);
      } finally {
        setLoading(verifyBtn, false, "Vérifier et continuer");
      }
    });
  }

  function setLoading(btn, isLoading, text) {
    if (isLoading) {
      btn.disabled = true;
      btn.innerText = text;
    } else {
      btn.disabled = false;
      btn.innerText = text;
    }
  }
});
